// extracted by mini-css-extract-plugin
module.exports = {"user":"styles__user___2g8Ca","checkboxWrapper":"styles__checkboxWrapper___32Xmd","name":"styles__name___3w0x0"};